export default __webpack_public_path__ + "static/Marilyn-c933c3f5605193dbe402009365171f5d.webp";